import { useMediaQuery } from '@material-ui/core';
import { Theme as DefaultTheme } from '@material-ui/core/styles/createMuiTheme';
import { useTheme } from '@material-ui/styles';
import React, { PropsWithChildren, ReactNode, useState } from 'react';

import ResizeButton from '../ResizeButton';

import useStyles from './ResizableContainer.styles';

interface ResizablePropsContainer {
  showResizeButton: boolean;
}

const ResizableContainer = ({
  children,
  showResizeButton,
}: PropsWithChildren<ResizablePropsContainer>) => {
  const [wrapWidth, setWrapWidth] = useState<string>('100%');
  const muiTheme: DefaultTheme = useTheme();
  const isLargeScreen = useMediaQuery(`(min-width:${muiTheme.breakpoints.values.lg}px)`);
  const classes = useStyles();
  const buttonMustBeShown = showResizeButton && isLargeScreen;

  return (
    <div className={classes.powerAppResizableWrapper}>
      <div style={{ width: wrapWidth }} className={classes.iframeContainer}>
        {buttonMustBeShown && (
          <ResizeButton className={classes.powerAppResizableButton} onConfigChange={setWrapWidth} />
        )}
        {children}
      </div>
    </div>
  );
};

export default ResizableContainer;
